import { PLATFORM } from 'Constants/device.APP_TARGET';
import { PLATFORM as mobile } from 'Constants/device.mobile';

export const isMobile = PLATFORM === mobile;
